// src/store/modules/inquiries/actions.js
import InquiriesApi from "../../../api/modules/InquiriesApi";

const createInquiries = (_, payload) => {
  return InquiriesApi.createInquiries(payload.context, payload.payload);
};

const listByClient = (_, payload) => {
  return InquiriesApi.listByClient(payload.context, payload.idClient);
};

const cancelInquiry = (_, payload) => {
  return InquiriesApi.cancelInquiry(payload.context, payload.id);
};

export default {
  createInquiries,
  listByClient,
  cancelInquiry
};



// WEBPACK FOOTER //
// ./src/store/modules/inquiries/actions.js